export default __webpack_public_path__ + "static/media/covenantofinvulnerability.7b83b6b6.png";